<!-- 
→ 26/11/2025
Si has llegado hasta aquí… ya no hay vuelta atrás. Mucha suerte, valiente
Aquí quedaron las almas de los devs que intentaron arreglarlo. Cuídalas.
⠄⠄⠄⠄⠄⠄⠄⣠⣴⣶⣿⣿⡿⠶⠄⠄⠄⠄⠐⠒⠒⠲⠶⢄⠄⠄⠄⠄⠄⠄
⠄⠄⠄⠄⠄⣠⣾⡿⠟⠋⠁⠄⢀⣀⡀⠤⣦⢰⣤⣶⢶⣤⣤⣈⣆⠄⠄⠄⠄⠄
⠄⠄⠄⠄⢰⠟⠁⠄⢀⣤⣶⣿⡿⠿⣿⣿⣊⡘⠲⣶⣷⣶⠶⠶⠶⠦⠤⡀⠄⠄
⠄⠔⠊⠁⠁⠄⠄⢾⡿⣟⡯⣖⠯⠽⠿⠛⠛⠭⠽⠊⣲⣬⠽⠟⠛⠛⠭⢵⣂⠄
⡎⠄⠄⠄⠄⠄⠄⠄⢙⡷⠋⣴⡆⠄⠐⠂⢸⣿⣿⡶⢱⣶⡇⠄⠐⠂⢹⣷⣶⠆
⡇⠄⠄⠄⠄⣀⣀⡀⠄⣿⡓⠮⣅⣀⣀⣐⣈⣭⠤⢖⣮⣭⣥⣀⣤⣤⣭⡵⠂⠄
⣤⡀⢠⣾⣿⣿⣿⣿⣷⢻⣿⣿⣶⣶⡶⢖⣢⣴⣿⣿⣟⣛⠿⠿⠟⣛⠉⠄⠄⠄
⣿⡗⣼⣿⣿⣿⣿⡿⢋⡘⠿⣿⣿⣷⣾⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣷⡀⠄⠄
⣿⠱⢿⣿⣿⠿⢛⠰⣞⡛⠷⣬⣙⡛⠻⠿⠿⠿⣿⣿⣿⣿⣿⣿⣿⠿⠛⣓⡀⠄
⢡⣾⣷⢠⣶⣿⣿⣷⣌⡛⠷⣦⣍⣛⠻⠿⢿⣶⣶⣶⣦⣤⣴⣶⡶⠾⠿⠟⠁⠄
⣿⡟⣡⣿⣿⣿⣿⣿⣿⣿⣷⣦⣭⣙⡛⠓⠒⠶⠶⠶⠶⠶⠶⠶⠶⠿⠟⠄⠄⠄
⠿⡐⢬⣛⡻⠿⢿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣷⡶⠟⠃⠄⠄⠄⠄⠄⠄
⣾⣿⣷⣶⣭⣝⣒⣒⠶⠬⠭⠭⠭⠭⠭⠭⠭⣐⣒⣤⣄⡀⠄⠄⠄⠄⠄⠄⠄⠄
⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣦⠄⠄⠄⠄⠄⠄⠄

Se hizo lo que se pudo con lo que había.
Ojalá tú puedas dejarlo mejor de lo que yo lo encontré.

Business Central me vio llorar… que no te vea a ti.

Y recordad chicos, no es un bug, es una feature.

PD: Si has llegado hasta aquí, te mereces un premio. Te dejo un chiste de programadores:
-->



<!-- Muchos soldados fueron a la guerra, pero pocos regresaron. -->


<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'integraciones' }">{{ $t("integraciones") }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t("businessCentral") }}</li>
          </ol>
        </nav>
      </div>
      <!-- Mandamos el idBusiness a ProductosBusinessCentral, que nos servirá 
      para obtener la lista de tpvs y las categorías y rellenar campos -->


      <!-- Tarjeta de Materias Primas -->
      <div v-if="developerPermission" class="col-md-4">
        <card>
          <div class="content-card">
            <ul class="list-files">
              <router-link v-if="cargandoProductosBC || numeroMateriasPrimasPendientes > 0" :to="{
                name: 'materiasprimasbusinesscentral',
                params: {
                  listBusinesses: listBusinesses,
                  materiasPrimasData: cargandoProductosBC ? undefined : materiasPrimas
                },
                query: { fromParent: true }
              }">
                <li class="disabled-title">
                  {{ $t('subproductos') }}
                  <span v-if="!cargandoProductosBC" class="circle-indicator"></span>
                  <br />
                  <span class="text-muted">
                    <template v-if="cargandoProductosBC"><i class="fas fa-spinner fa-spin"></i> {{ $t('obteniendoDatos') }}</template>
                    <label v-else class="subtitle-fix"
                      v-html="$t('sincronizaMateriasPrimasBusinessCentralSubtitle', { MATERIAS_PRIMAS_LENGTH: numeroMateriasPrimasPendientes })">
                    </label>
                  </span>
                </li>
              </router-link>
              <li v-else class="disabled-link">
                <span class="disabled-title">{{ $t('subproductos') }}</span>
                <br />
                <span class="text-muted">
                  {{ $t('noHayParaActualizar') }}
                </span>
              </li>

            </ul>
          </div>
        </card>
      </div>

      <!-- Tarjeta de Productos -->
      <div class="col-md-4">
        <card>
          <div class="content-card">
            <ul class="list-files">

              <!-- Productos -->
              <router-link v-if="cargandoProductosBC || numeroProductosPendientes > 0" :to="{
                name: 'productosbusinesscentral',
                params: {
                  listBusinesses: listBusinesses,
                  productosData: cargandoProductosBC ? undefined : productosPendientes
                },
                query: { fromParent: true }
              }">
                <li class="disabled-title">
                  {{ $t('productos') }}
                  <span v-if="!cargandoProductosBC" class="circle-indicator"></span>
                  <br />
                  <span class="text-muted">
                    <template v-if="cargandoProductosBC"><i class="fas fa-spinner fa-spin"></i> {{ $t('obteniendoDatos') }}</template>
                    <label v-else-if="numeroProductosPendientes" class="subtitle-fix"
                      v-html="$t('sincronizaProductosBusinessCentralSubtitle', { NUMERO_PRODUCTOS_PENDIENTES: numeroProductosPendientes })">
                    </label>
                  </span>
                </li>
              </router-link>
              <li v-else class="disabled-link">
                <span class="disabled-title">{{ $t('productos') }}</span>
                <br />
                <span class="text-muted">
                  {{ $t('noHayParaActualizar') }}
                </span>
              </li>

              <!-- Comportamiento original comentado por pruebas -->
              <!-- <router-link
                v-if="businessCentral && !hayMateriasPrimasPendientes"
                :to="{ name: 'productosbusinesscentral', params: { listBusinesses: listBusinesses } }"
              >
                <li>
                  {{ $t('productos') }}
                  <span v-if="numeroProductosPendientes > 0" class="circle-indicator"></span>
                  <br />
                  <span class="text-muted">
                    {{ $t('sincronizaProductosBusinessCentralSubtitleNum') }}
                    <span v-if="numeroProductosPendientes > 0" class="materias-primas-count" >
                      {{ numeroProductosPendientes }}
                    </span>
                  </span>
                </li>
              </router-link>

              <li v-else-if="hayMateriasPrimasPendientes" class="disabled-link">
                {{ $t('productos') }}
                <br />
                <span class="text-muted">
                  {{ $t('completaProductosBussinessCentralSubtitle') }}
                </span>
              </li> -->

            </ul>
          </div>
        </card>
      </div>

      <!-- Tarjeta de Formas de Pago -->
      <div class="col-md-4">
        <card>
          <div class="content-card">
            <ul class="list-files">
              <template v-if="businessCentral">
                <router-link v-if="cargandoFormasPagoBC || formasPagoTotal > 0" :to="{
                  name: 'formasdepagobusinesscentral',
                  params: {
                    pag: 1,
                    listBusinesses: listBusinesses
                    // formasPagoData: formasPagoParaSincronizar
                  }
                }">

                  <!-- {{ formasPagoParaSincronizar }} -->
                  <li class="disabled-title">
                    {{ $t('formasDePago') }}
                    <span v-if="!cargandoFormasPagoBC" class="circle-indicator"></span>
                    <br />
                    <span class="text-muted">
                      <template v-if="cargandoFormasPagoBC"><i class="fas fa-spinner fa-spin"></i> {{ $t('obteniendoDatos') }}</template>
                      <label v-else class="subtitle-fix"
                        v-html="$t('sincronizaFormasDePagoBusinessCentralSubtitle', { NUMERO_FORMAS_PAGO_PENDIENTES: formasPagoTotal })">
                      </label>
                    </span>
                  </li>
                </router-link>
                <li v-else class="disabled-link">
                  <span class="disabled-title">{{ $t('formasDePago') }}</span>
                  <br />
                  <span class="text-muted">
                    {{ $t('noHayParaActualizar') }}
                  </span>
                </li>
              </template>
            </ul>
          </div>
        </card>
      </div>

      <!-- Exportación diaria de ventas -->
      <!-- Tarjeta de Exportación Diaria: solo con la restricción 79 -->
      <div v-if="permisoExportacionBC" class="col-md-4">
        <card>
          <div class="content-card">
            <ul class="list-files">

              <!-- Si existe conexión con Business Central -->
              <router-link v-if="businessCentral && !exportacionEnabled" :to="{
                name: 'exportacionventasbc',
                params: { 
                  listBusinesses: listBusinesses, 
                  idCompany: idCompany 
                }
              }">
                <li class="disabled-title">
                  {{ $t('dailyExportCardTitle') }}
                  <br />
                  <span class="text-muted">
                    <label class="subtitle-fix" v-html="$t('dailyExportCardSubtitle')">
                    </label>
                  </span>
                </li>
              </router-link>

              <!-- Deshabilitada la card -->
              <li v-else class="disabled-link">
                <span class="disabled-title">{{ $t('dailyExportCardTitle') }}</span>
                <br />
                <span class="text-muted">
                  {{ $t('exportacionDeshabilitada') }}
                </span>
              </li>

            </ul>
          </div>
        </card>
      </div>

      <!-- Tarjeta de Bajas -->
      <div class="col-md-4">
        <card>
          <div class="content-card">
            <ul class="list-files">
              <template v-if="businessCentral">
                <router-link :to="{
                  name: 'downgradesbusinesscentral',
                  params: {
                    pag: 1,
                    listBusinesses: listBusinesses,
                    formasPagoData: formasPagoParaSincronizar
                  }
                }">
                  <li class="disabled-title">
                    {{ $t('bajaEntidades') }}
                    <!-- <span class="circle-indicator"></span> -->
                    <br />
                    <span class="text-muted">
                      <label class="subtitle-fix" v-html="$t('checkBajaEntidades')">
                      </label>
                    </span>
                  </li>
                </router-link>
              </template>
            </ul>
          </div>
        </card>
      </div>

    </div>

    <!-- Modal Bajas de Materias primas -->
    <modal name="modal-downgrades-subproducts" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
      <div>
        <!-- Header -->
        <div class="modal-header wrapperTitle">
          <h4 style="margin: 0px">{{ $t('subproductDowngrades') }}</h4>
          <!-- <span class="close-btn" @click="closeDowngradesModal">&times;</span> -->
        </div>

        <!-- Body -->
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <!-- Totales -->
              <div class="form-group" v-if="downgradesSubproducts">
                <label>{{ $t("summary") }}</label>
                <p>
                  <strong>{{ $t("totalDowngrades") }}:</strong> {{ downgradesSubproducts.totalDowngrades }}<br>
                  <strong>{{ $t("totalAffectedRecipes") }}:</strong> {{ downgradesSubproducts.totalAffectedRecipes
                  }}
                </p>
              </div>
            </div>

            <!-- Lista de subproducts dados de baja -->
            <div class="col-md-12"
              v-if="downgradesSubproducts && downgradesSubproducts.downgrades && downgradesSubproducts.downgrades.length > 0">
              <div class="form-group">
                <label>{{ $t("downgradedProducts") }}</label>
                <ul class="list-group">
                  <li v-for="(subproduct, index) in downgradesSubproducts.downgrades"
                    :key="'DOWN-' + subproduct.numierId" class="list-group-item">
                    <strong>#{{ index + 1 }} {{ subproduct.subProductName || $t("unknownProduct") }}</strong>
                    <!-- <span class="text-muted"> (ID: {{ subproduct.numierId }})</span> -->

                    <!-- Recetas afectadas -->
                    <div v-if="subproduct.affectedRecipes && subproduct.affectedRecipes.length > 0" class="mt-2">
                      <label style="font-weight: bold;">{{ $t("affectedRecipes") }}:</label>
                      <ul class="pl-3">
                        <li v-for="recipe in subproduct.affectedRecipes" :key="'REC-' + recipe.recipeId"
                          class="flex items-center gap-2">
                          <i class="fa fa-cutlery"></i>
                          {{ recipe.name }}
                        </li>
                      </ul>
                    </div>
                    <div v-else class="text-muted">
                      {{ $t("noRecipesAffected") }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="closeSubproductsDowngradesModal" class="btn btn-secondary">
              <i class="fas fa-times"></i> {{ $t("cerrar") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <!-- Modal Bajas de Productos -->
    <modal name="modal-downgrades-products" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
      <div>
        <div class="modal-header wrapperTitle">
          <h4 style="margin: 0px">{{ $t('productDowngrades') }}</h4>
          <!-- <span class="close-btn" @click="closeDowngradesModal">&times;</span> -->
        </div>

        <!-- Body -->
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <!-- Totales -->
              <div class="form-group" v-if="downgradesProducts">
                <label>{{ $t("summary") }}</label>
                <p>
                  <strong>{{ $t("totalDowngrades") }}:</strong> {{ downgradesProducts.totalDowngrades }}<br>
                  <strong>{{ $t("totalAffectedRecipes") }}:</strong> {{ downgradesProducts.totalAffectedRecipes }}
                </p>
              </div>
            </div>

            <!-- Lista de productos dados de baja -->
            <div class="col-md-12"
              v-if="downgradesProducts && downgradesProducts.downgrades && downgradesProducts.downgrades.length > 0">
              <div class="form-group">
                <label>{{ $t("downgradedProducts") }}</label>
                <ul class="list-group">
                  <li v-for="(product, index) in downgradesProducts.downgrades" :key="'DOWN-' + product.numierId"
                    class="list-group-item">
                    <strong>#{{ index + 1 }} {{ product.productName || $t("unknownProduct") }}</strong>
                    <!-- <span class="text-muted"> (ID: {{ product.numierId }})</span> -->

                    <!-- Recetas afectadas -->
                    <div v-if="product.affectedRecipes && product.affectedRecipes.length > 0" class="mt-2">
                      <label style="font-weight: bold;">{{ $t("affectedRecipes") }}:</label>
                      <ul class="pl-3">
                        <li v-for="recipe in product.affectedRecipes" :key="'REC-' + recipe.recipeId"
                          class="flex items-center gap-2">
                          <i class="fa fa-cutlery"></i>
                          {{ recipe.name }}
                        </li>
                      </ul>
                    </div>
                    <div v-else class="text-muted">
                      {{ $t("noRecipesAffected") }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="closeProductsDowngradesModal" class="btn btn-secondary">
              <i class="fas fa-times"></i> {{ $t("cerrar") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <!-- Modal Bajas de Unidades -->
    <modal name="modal-downgrades-units" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
      <div>
        <div class="modal-header wrapperTitle">
          <h4 style="margin: 0px">{{ $t('unidadesMedidaDadasDeBaja') }}</h4>
          <!-- <span class="close-btn" @click="closeDowngradesModal">&times;</span> -->
        </div>

        <!-- Body -->
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <!-- Totales -->
              <div class="form-group" v-if="downgradesUnits">
                <label>{{ $t("summary") }}</label>
                <p>
                  <strong>{{ $t("totalDowngrades") }}:</strong> {{ downgradesUnits }}<br>
                  <strong>{{ $t("totalAffectedRecipes") }}:</strong> {{ downgradesUnits }}
                </p>
              </div>
            </div>

            <!-- Lista de productos dados de baja -->
            <div class="col-md-12"
              v-if="downgradesUnits && downgradesUnits.downgrades && downgradesUnits.downgrades.length > 0">
              <div class="form-group">
                <label>{{ $t("downgradedProducts") }}</label>
                <ul class="list-group">
                  <li v-for="(product, index) in downgradesUnits.downgrades" :key="'DOWN-' + product.numierId"
                    class="list-group-item">
                    <strong>#{{ index + 1 }} {{ product.productName || $t("unknownProduct") }}</strong>
                    <!-- <span class="text-muted"> (ID: {{ product.numierId }})</span> -->

                    <!-- Recetas afectadas -->
                    <div v-if="product.affectedRecipes && product.affectedRecipes.length > 0" class="mt-2">
                      <label style="font-weight: bold;">{{ $t("affectedRecipes") }}:</label>
                      <ul class="pl-3">
                        <li v-for="recipe in product.affectedRecipes" :key="'REC-' + recipe.recipeId"
                          class="flex items-center gap-2">
                          <i class="fa fa-cutlery"></i>
                          {{ recipe.name }}
                        </li>
                      </ul>
                    </div>
                    <div v-else class="text-muted">
                      {{ $t("noRecipesAffected") }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="closeProductsDowngradesUnitsModal" class="btn btn-secondary">
              <i class="fas fa-times"></i> {{ $t("cerrar") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <!-- Modal Bajas de lineas de receta -->
    <modal name="modal-downgrades-lines" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
      <div>
        <div class="modal-header wrapperTitle">
          <h4 style="margin: 0px">{{ $t('bajasDeProductos') }}</h4>
        </div>

        <!-- Mensaje de error -->
        <div v-if="downgradesError" class="alert alert-danger mt-3 mx-3">
          <i class="fas fa-exclamation-triangle"></i>
          {{ downgradesError }}
        </div>

        <!-- Body (solo si hay resultados y no hay error) -->
        <div class="modal-body" v-if="downgradesLines && !downgradesError">
          <div class="row">
            <div class="col-md-12">
              <label>{{ $t("relacionesProcesadas") }}</label>
              <ul class="list-group">
                <li v-for="(line, index) in downgradesLines" :key="index"
                  class="list-group-item d-flex justify-content-between align-items-center"
                  :class="{ 'list-group-item-success': line.deleted, 'list-group-item-warning': !line.deleted }">
                  <div>
                    <strong>#{{ index + 1 }}</strong>
                    {{ $t("producto") }}: {{ line.idProduct }}
                    → {{ $t("subproducto") }}: {{ line.idSubproduct }}
                  </div>
                  <div>
                    <small>{{ line.message }}</small>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="closeProductsDowngradesLinesModal" class="btn btn-secondary">
              <i class="fas fa-times"></i> {{ $t("cerrar") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

  </div>
</template>
<script>

import { mapState } from 'vuex';
import { Loading } from 'element-ui';
import bus from '../../../../bus';
export default {
  created() {
    this.$store.dispatch("setNameRoute", "Business Central");

    // Guardamos el listBusinesses pasado como parámetro en la variable local
    // this.listBusinesses = this.$route.params.listBusinesses;
    // console.log(" > Estoy en BusinessCentral.vue y tengo la listBusinesses:", this.listBusinesses);

    bus.$on('get-business', (idBusiness) => {
      this.idBusiness = idBusiness;
      this.idsTPV = [];
      this.idTpv = 0;
    });

    // if (!this.listBusinesses) {
    //   console.warn("listBusinesses no encontrado, redirigiendo a /integraciones...");
    //   this.$router.push({ name: "integraciones", params: { redirected: true } });
    // }

    // console.log("hola");
    // console.log("this.idBusiness", this.idBusiness);

    const avisarError = () => this.$notify({
      title: this.$t('error'),
      message: this.$t('errorCargandoDatos'),
      type: 'danger'
    });

    this.cargandoProductosBC = true;
    this.cargandoFormasPagoBC = true;
    const cargarDatosBC = () => {
      this.getFormasPagoBusinessCentral()
        .catch(avisarError)
        .finally(() => { this.cargandoFormasPagoBC = false; });

      this.getDatosBusinessCentral()
        .catch(avisarError)
        .finally(() => { this.cargandoProductosBC = false; });
    };

    this.loadingGeneral = Loading.service({ text: this.$t('cargando') });
    Promise.all([
      this.getDeveloperModePermission(),
      this.comprobarPermisoExportacionBC(),
      this.getCompanies(),
      // this.getSubproductsDowngrades(),
      // this.getProductsDowngrades(),
      // this.getProductsDowngradesUnits(),
      // this.getProductsDowngradesLines(),


      // this.getProductsDowngradesLinesUnits(),
    ])
      .then(() => {
        this.loadingGeneral.close();
      })
      .catch((err) => {
        console.error("Error al obtener los datos de Business Central:", err);
        this.loadingGeneral.close();
        avisarError();
      })
      .finally(cargarDatosBC);

  },

  data() {
    return {
      businessCentral: true,
      productosPendientes: [],
      matPrimasSincro: [],
      materiasPrimas: {
        pendientesActualizar: [],
        pendientesSincronizar: []
      },
      materiasPrimasPendientes: [],
      formasDePagoPendientes: [],
      formasDePagoActualizar: [],
      formasPagoTotal: 0,
      listBusinesses: [],
      loading: false,
      cargandoProductosBC: false,
      cargandoFormasPagoBC: false,

      idBusiness: this.$store.getters.idBusiness,
      idCompany: null,
      listCompany: [],

      // Flag para prohibirle entrar en la exportación de ventas
      exportacionEnabled: false,
      downgradesProducts: [],
      downgradesSubproducts: [],
      downgradesUnits: [],
      downgradesLines: [],
      downgradesError: null,
      developerPermission: false,
      // Restricción 79 (permisiva): ver y exportar ventas a Business Central
      permisoExportacionBC: false,
    };
  },

  computed: {
    ...mapState(["listaSectores", "sectores"]),

    // Productos pendientes (tanto para crear como para actualizar)
    productosParaSincronizar() {
      if (!this.productosPendientes) return [];
      return this.productosPendientes.filter(producto =>
        ['pendienteSincronizar', 'pendienteActualizar'].includes(producto.tipoPendiente)
      );
    },

    numeroProductosPendientes() {
      return this.productosParaSincronizar.length;
    },

    // Materias primas pendientes (solo para actualizar)
    materiasParaActualizar() {
      if (!this.materiasPrimasPendientes) return [];
      return this.materiasPrimasPendientes.filter(materia =>
        materia.tipoPendiente === 'pendienteActualizar'
      );
    },

    numeroMateriasPrimasPendientes() {
      // return this.materiasParaActualizar.length;
      return this.materiasPrimas.pendientesActualizar.length + this.materiasPrimas.pendientesSincronizar.length;
    },

    // Formas de pago pendientes (tanto para crear como para actualizar)
    formasPagoParaSincronizar() {
      // Asumiendo que formasDePagoPendientes ya incluye tanto crear como actualizar
      return this.formasDePagoPendientes || 0;
    },

    numeroFormasPagoPendientes() {
      return this.formasPagoParaSincronizar;
    }
  },

  methods: {
    /* Comprueba un permiso contra general/getPermission, que respeta
       restrictions_info.tipo: las permisivas conceden con la fila presente. */
    async comprobarPermiso(idRestriccion, idBusiness) {
      // Si no se pasa negocio, la API responde si lo tiene en ALGUNO de los suyos.
      // En esta pantalla no hay negocio seleccionado fiable, así que es la pregunta
      // correcta: el módulo de exportación vuelve a comprobarlo por negocio.
      try {
        const response = await this.axios.get(
          this.$store.getters.apiUrl + "general/getPermission",
          {
            params: {
              jwt: this.$store.getters.jwt,
              idBusiness: idBusiness || "",
              idRestriccion: idRestriccion,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          }
        );

        return !!(response.data && response.data.result && response.data.result.permitido);
      } catch (error) {
        console.error("Error comprobando el permiso " + idRestriccion + ":", error);
        // Si no se puede comprobar, no se concede: esto es control de acceso.
        return false;
      }
    },

    /* La 79 decide si el usuario ve siquiera la tarjeta de exportación.
       Aquí NO se filtra por negocio a propósito: en esta pantalla idBusiness sale
       del store y puede venir vacío (el evento 'get-business' de la línea 528 no lo
       emite nadie en todo el front), así que se pregunta si tiene el permiso en
       alguno de sus negocios. El control por negocio lo hace el propio módulo. */
    async comprobarPermisoExportacionBC() {
      this.permisoExportacionBC = await this.comprobarPermiso(79, null);
    },

    /* Método para visualizar secciones ocultas */
    async getDeveloperModePermission() {
      const idConfig = 133;

      try {
        let config = {
          params: {
            jwt: this.$store.getters.jwt,
            idConfig: idConfig
          },
          headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
        };

        const response = await this.axios.get(
          this.$store.getters.apiUrl + "general/getDeveloperModePermission",
          config
        );

        if (response.data.permission) {
          this.developerPermission = response.data.permission;
        }
        
      } catch (error) {
        console.error("Error al obtener el permiso de modo desarrollador:", error);
      }
    },
    /* Método para obtener los productos y materias primas desde Business Central */
    async getDatosBusinessCentral() {
      try {
        let config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
        };

        const response = await this.axios.post(
          this.$store.getters.apiUrl + "products/getProductosFromBusinessCentral",
          { jwt: this.$store.getters.jwt },
          config
        );

        if (response.data.response) {
          this.productosPendientes = response.data.productos || [];

          this.matPrimasSincro = (response.data.materiasprimas).filter(item => item.tipoPendiente === 'pendienteSincronizar' && item.esProduct) || [];
          // this.materiasPrimasPendientes = response.data.materiasprimas || [];

          // this.productosPendientes.push(...this.matPrimasSincro);

          // this.productosPendientes.push((response.data.materiasprimas).filter(item => item.tipoPendiente === 'pendienteSincronizar') || []);

          this.materiasPrimasPendientes = (response.data.materiasprimas).filter(item => item.tipoPendiente === 'pendienteActualizar') || [];

          this.materiasPrimas.pendientesActualizar = this.materiasPrimasPendientes;
          this.materiasPrimas.pendientesSincronizar = this.matPrimasSincro;

          // console.log(" > Productos pendientes:", this.productosPendientes);
          // console.log(" > Materias primas pendientes actualizar:", this.materiasPrimasPendientes);
          // console.log(" > Materias primas para sincronizar:", this.matPrimasSincro);

        }
        return response;
      } catch (error) {
        console.error("Error al obtener datos de Business Central:", error);
        throw error;
      }
    },

    async getFormasPagoBusinessCentral() {
      // Si ya tenemos el conteo, lo retornamos directamente
      if (this.formasDePagoPendientes > 0) {
        return {
          data: {
            response: true,
            data: { total: this.formasDePagoPendientes }
          }
        };
      }

      try {
        let config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
        };

        const response = await this.axios.get(
          this.$store.getters.apiUrl + "businesscentral/getPaymentMethodSyncCounts",
          config
        );

        if (response.data.response && response.data.data) {
          const counts = response.data.data;
          this.formasDePagoPendientes = counts.toSync;
          this.formasDePagoActualizar = counts.toUpdate;
          this.formasPagoTotal = counts.total;

        }

        return response;
      } catch (error) {
        console.error("Error al obtener conteo de formas de pago desde Business Central:", error);
        throw error;
      }

    },

    async getCompanies() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt
        },
        headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
      };

      let vm = this;
      try {
        const response = await this.axios.get(
          this.$store.getters.apiUrl + "general/getCompaniesByUser",
          config
        );
        if (!vm.idCompany) {
          vm.idCompany = response.data.result[0].id;
        }
        vm.listCompany = response.data.result;
      
        await vm.getBusinessListByCompany(); // ahora sí funciona
        
      } catch (error) {
        console.error("Error al obtener companies:", error);
        throw error;
      }
      // await this.axios.get(this.$store.getters.apiUrl + "general/getCompaniesByUser", config)
      //   .then(function (response) {

      //     if (!vm.idCompany) {
      //       vm.idCompany = response.data.result[0].id;
      //       //console.log(" > La Company seleccionada es:", vm.idCompany,);
      //     }
      //     vm.listCompany = response.data.result;

      //     // console.log(" > Lista de Companies actualizada:", vm.listCompany,);
      //     await vm.getBusinessListByCompany()

      //   })
      //   .catch(function (error) {
      //     console.log(error);
      //   });
    },

    async getBusinessListByCompany() {
      var config = {
        params: {
          idCompany: this.idCompany,
          jwt: this.$store.getters.jwt
        },
        headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
      };
      // console.log("> El id company es:", this.idCompany);
      let vm = this;
      await this.axios.get(this.$store.getters.apiUrl + "businesses/getBusinessesByIdCompany", config)
        .then(function (response) {

          vm.listBusinesses = response.data;

          // Si vengo de un redirect, le notifico al usuario por qué ha sido redirigido a Integraciones.
          if (vm.mostrarNotificacionRedirect) {
            vm.checkRedirect();
          }

        })
        .catch(function (error) {
          console.log(error);
          throw error;
        });
    },

    // Modales movidos al padre
    openProductsDowngradesModal() {
      this.$modal.show("modal-downgrades-products");
    },

    closeProductsDowngradesModal() {
      this.$modal.hide("modal-downgrades-products");
    },

    openSubproductsDowngradesModal() {
      this.$modal.show("modal-downgrades-subproducts");
    },

    closeSubproductsDowngradesModal() {
      this.$modal.hide("modal-downgrades-subproducts");
    },

    openProductsDowngradesUnitsModal() {
      this.$modal.show("modal-downgrades-units");
    },

    closeProductsDowngradesUnitsModal() {
      this.$modal.hide("modal-downgrades-units");
    },

    openProductsDowngradesLinesModal() {
      this.$modal.show("modal-downgrades-lines");
    },

    closeProductsDowngradesLinesModal() {
      this.$modal.hide("modal-downgrades-lines");
    },

    // Métodos de los modales movidos al padre
    async getSubproductsDowngrades() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      await this.axios
        .get(this.$store.getters.apiUrl + "subproducts/getDowngrades", config)
        .then((response) => {
          if (response.data.success && response.data.downgrades.length) {
            this.downgradesSubproducts = response.data;
            this.openSubproductsDowngradesModal();

            // console.log("Baja de productos:", response.data.downgrades);
            // console.log("Bajas totales:", response.data.totalDowngrades, " | Recetas afectadas:", response.data.totalAffectedRecipes);
          }
        })
        .catch(function (error) {
          console.error("Error al obtener las bajas de los productos:", error);
        });
    },

    getProductsDowngrades() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "products/getDowngrades", config)
        .then((response) => {
          if (response.data.success && response.data.downgrades.length) {
            this.downgradesProducts = response.data;
            this.openProductsDowngradesModal();

            // console.log("Baja de productos:", response.data.downgrades);
            // console.log("Bajas totales:", response.data.totalDowngrades, " | Recetas afectadas:", response.data.totalAffectedRecipes);
          }
        })
        .catch(function (error) {
          console.error("Error al obtener las bajas de los productos:", error);
        });
    },


    getProductsDowngradesUnits() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      this.axios
        .get(this.$store.getters.apiUrl + "businesscentral/deleteUnidadMedia", config)
        .then((response) => {
          // console.log("Respuesta de bajas de productos:", response.data);

          // Verifica la propiedad correcta
          if (response.data.response === true && response.data.result > 0) {
            this.downgradesUnitis = response.data.result;
            this.openProductsDowngradesUnitsModal();
          }
        })
        .catch((error) => {
          console.error("Error al obtener las bajas de los productos:", error);
        });
    },

    getProductsDowngradesLines() {
      const config = {
        params: { jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      // console.log("Las downsgrades lines se van a pedir");

      this.axios
        .get(this.$store.getters.apiUrl + "businesscentral/downRecepiesProducts", config)
        .then((response) => {
          // console.log("Respuesta de bajas de productos:", response.data);

          if (response.status === 200) {
            if (response.data.response === true) {
              this.downgradesError = null;
              this.downgradesLines = response.data.results;
              this.openProductsDowngradesLinesModal();
            } else {
              this.downgradesError = response.data.message || "Ocurrió un error al obtener las bajas.";
              this.downgradesLines = null;
            }
          }
        })
        .catch((error) => {
          console.error("Error al obtener las bajas de los productos:", error);
          this.downgradesError = "Error de conexión con el servidor.";
          this.openProductsDowngradesLinesModal();
        });
    },

  }
};
</script>

<style scoped>
h3 {
  margin: 10px 0;
  color: #1E22AA;
  font-family: "Roboto", "Helvetica Neue", Arial, sans-serif;
}

h2 {
  margin: 10px 5px;
  font-family: "Numier", "Helvetica Neue", Arial;
  font-weight: bold;
  color: #1E22AA;
  font-size: 25px;
}

i {
  font-size: 20px;
}

.list-files {
  padding: 0;
  margin-bottom: 0px;
  min-height: 100px;
}

.list-files a:first-child li {
  border-top: none;
}

.list-files a {
  display: block;
  text-decoration: none;
  min-height: 100px;
}

.list-files a li {
  list-style: none;
  padding: 15px 20px;
  font-size: 1.1em;
  border-top: 1px solid #bbb;
  /*font-weight: bold;*/
  color: #252422;
  height: 100%;
  box-sizing: border-box;
  min-height: 100%;
}

.list-files a li span {
  font-size: 12px;
}

.list-files p {
  margin: 0;
}

.list-files a:hover li {
  cursor: pointer;
  background-color: rgba(0, 153, 130, 0.2);
  min-height: 100px;
}

.content-card {
  border-top: 2px solid #00A3AD;
  padding: 0;
  height: 100%;
  min-height: 100px;
  box-sizing: border-box;
}

.prox {
  font-weight: 400;
  font-size: 0.8em;
}

/* Estilos número materias primas  */
.materias-primas-count {
  font-size: 0.9em !important;
  font-family: "Numier", "Helvetica Neue", Arial, sans-serif;
  font-weight: bold;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
  line-height: 1;
  display: inline-block;
  margin-top: 5px;
}

.subtitle-fix {
  font-size: 14px;
  font-weight: normal;
  color: #808080;
}

.circle-indicator {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-left: 8px;
  margin-bottom: 2px;
  border-radius: 50%;
  background-color: red;
}

/* EStilos para la tarjeta de productos cuando no este habilitada */
.disabled-link {
  list-style: none;
  padding: 15px 20px;
  color: #9a9a9a;
  pointer-events: none;
}

/* Estilos para títulos deshabilitados tanto en enlaces como en listas */
.disabled-title,
.disabled-link .disabled-title {
  font-size: 1.1em;
}

/* Estilos específicos para enlaces deshabilitados */
.disabled-link .disabled-title {
  color: #9a9a9a;
  font-weight: normal;
}

.disabled-link .text-muted {
  font-size: 14px;
  display: inline-block;
}

/* Aplicar estilos deshabilitados a toda la tarjeta cuando contiene un enlace deshabilitado */
.card:has(.disabled-link) {
  cursor: not-allowed;
  background-color: #f5f5f5;
  opacity: 0.8;
}

/* Asegurarse de que el contenido de la tarjeta no sea clickable cuando está deshabilitada */
.card:has(.disabled-link) .content-card {
  cursor: not-allowed;
  pointer-events: none;
}

/* Estilos para la tarjeta deshabilitada */
.card:has(.disabled-link) {
  cursor: not-allowed;
  background-color: #f5f5f5;
  opacity: 0.8;
}

/* Asegurar que el contenido de la tarjeta no sea clickable cuando está deshabilitada */
.card:has(.disabled-link) .content-card {
  cursor: not-allowed;
  pointer-events: none;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Integraciones/BusinessCentral/BusinessCentral.vue